export enum DonorCenterInvoiceStatus {    
    Unknown = 0,
    PendingDataEntry = 1,
    SentToRecipientCenter = 2,
    PendingMoreDataByRecipientCenter = 3,
    AcceptedByRecipientCenter = 4,
    AcceptedByRecipientCenterDueToNonResponse = 5,
    PaymentReceivedByRecipientCenter = 10,
    PaymentSentToDonorCenter = 20,
    TimedOutDonorCenterDidNotSubmit = 99
}